import React from 'react';
import { View, FlatList } from 'react-native-web';

// Custom Components
import { NavBar } from '../../components';

// Configs
import GLOBAL from '../../configs/config_global';
import { STATE_KEYS, useGlobalState } from '../../configs/config_state';

// Navigation
import * as RootNavigation from '../../navigation/RootNavigation';
import { useRoute } from '@react-navigation/native';
import RouteKeys from '../../navigation/RouteKeys';
import { cloneDeep } from 'lodash';

export function PastHood() {
    const {
        renderSectionItem = () => <View/>
    } = useRoute()?.params || {};

    // region Global State
    const [pastHoodData, setPastHoodData] = useGlobalState(STATE_KEYS.PAST_HOOD_DATA);
    // endregion

    // region Function - On Hood Item Pressed
    const _onHoodItemPressed = (item) => {
        RootNavigation.push(RouteKeys.HOOD_DETAILS, {
            hoodData: item,
            onFeedbackSubmitted: (updatedHoodData) => {
                const tempArr = cloneDeep(pastHoodData);
                const hoodIndex = tempArr.findIndex((item) => item.id === updatedHoodData.id);
                if (hoodIndex > -1) {
                    tempArr.splice(hoodIndex, 1, updatedHoodData);
                    setPastHoodData(tempArr);
                }
            }
        });
    }
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ width: '100%', flex: 1, backgroundColor: GLOBAL.COLOR.MAIN_BACKGROUND }}>
            {/* Nav Bar */}
            <NavBar
                title={'Past Hood Events'}
                leftButtonIconName={'keyboard-arrow-left'}
                leftButtonIconSize={40}
                leftButtonOnPress={() => RootNavigation.goBack()}
            />

            {/* Content */}
            <FlatList
                data={pastHoodData}
                style={{ flex: 1, width: '100%' }}
                contentContainerStyle={{ paddingBottom: 16, paddingHorizontal: '15%' }}
                keyExtractor={(item) => item.id?.toString()}
                renderItem={({ item }) => renderSectionItem(item, true, () => _onHoodItemPressed(item))}
                ItemSeparatorComponent={() => <View style={{ height: 1, width: '100%', backgroundColor: GLOBAL.COLOR.DIVIDER }}/>}
            />
        </View>
    );
    // endregion
}
